var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import dsbridge from "dsbridge";
import * as event from "./event";
export * from "./event";
/**
 * 根据userAgent识别App信息
 * @date 2020-05-20
 * @returns {false|{isApp,merchat,version,platform}}
 */
function checkApp() {
    var res = window.navigator.userAgent.match(/StApp\/([a-zA-Z0-9]*)\/(\d\.\d\.\d)\/([a-zA-Z0-9]*)/);
    if (res) {
        return {
            /**
             * 是否是APP内打开
             */
            isApp: true,
            /**
             * 当前的App品牌
             * bb 或者 m6
             */
            merchant: res[1],
            /**
             * 当前App版本号
             */
            version: res[2],
            /**
             * 当前手机系统
             * iOS 或者 android
             */
            platform: res[3],
        };
    }
    return false;
}
function proxyCall(name, params, callback) {
    return new Promise(function (resolve, reject) {
        var hasNativeMethod = dsbridge.hasNativeMethod(name);
        if (!hasNativeMethod) {
            return reject("no native method [" + name + "]");
        }
        dsbridge.call(name, params, function (res) {
            if (callback) {
                callback(res, resolve, reject);
            }
            else {
                if (typeof res === "string") {
                    res = JSON.parse(res);
                }
                if (res === undefined) {
                    resolve(res);
                }
                else if (res.code === 1) {
                    resolve(res);
                }
                else {
                    reject(res);
                }
            }
        });
    });
}
/**
 * 跳转到h5的某个详情页（顶部返回用app原生）
 * @callName jumpToH5Page
 */
function jumpToH5Page(params) {
    return proxyCall("jumpToH5Page", params);
}
/**
 * 调用浏览器跳转网址
 * @callName jumpToBrowserPage
 */
function jumpToBrowserPage(params) {
    return proxyCall("jumpToBrowserPage", params);
}
/**
 * 跳转到原生页面
 * @callName jumpToNativePage
 * @demo
 * jumpToNativePage({
 *   type: "userCenter",
 *   data: undefined,
 * });
 */
function jumpToNativePage(params) {
    return proxyCall("jumpToNativePage", params);
}
/**
 * 跳转到原生app登录页，登录成功会触发onLoginSuccess事件
 * @callName jumpToNativeLogin
 */
function jumpToNativeLogin() {
    return proxyCall("jumpToNativeLogin", {});
}
/**
 * 获取用户基本登录信息（token等）, 返回数据类型与上面接口成功之后的返回值相同
 * @callName getLoginInfo
 */
function getLoginInfo() {
    return proxyCall("getLoginInfo", {});
}
/**
 * 获取代理的用户信息
 */
function getAgentLoginInfo() {
    return proxyCall("getAgentLoginInfo", {});
}
/**
 * 获取原生app提供的其他参数
 * @callName getNativeInfo
 */
function getNativeInfo() {
    return proxyCall("getNativeInfo", {});
}
/**
 * 通知app给出消息提示（比如：更新了10条信息） type: info|warn|error|success
 *  @callName notify
 */
function notify(params) {
    return proxyCall("notify", params);
}
/**
 * 获取当前的主题
 * @callName getCurrentTheme
 */
function getCurrentTheme() {
    return proxyCall("getCurrentTheme", {});
}
/**
 * 获取当前的语言
 * @callName getCurrentLanguage
 */
function getCurrentLanguage() {
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, proxyCall("getCurrentLanguage", {})];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, {
                            data: __assign({ lang: data.language }, data),
                        }];
            }
        });
    });
}
/**
 * 获取当前的国家
 * 比如：日本独立站返回 JP，菲律宾的返回 PH
 * @callName getCountry
 */
function getCountry() {
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, proxyCall("getCountry", {})];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
}
/**
 * 测试app内如果没有这个方法应该会报错
 * @callName testNotExist
 */
function testNotExist() {
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, proxyCall("testNotExist", {})];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
}
/**
 * 获取当前的coinCode
 * @callName getCurrentCoinCode
 */
function getCurrentCoinCode() {
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, proxyCall("getCurrentCoinCode", {})];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
}
/**
 * 获取原生顶部信息bar的高度
 * @callName getNativeTopBarHeight
 */
function getNativeTopBarHeight() {
    return proxyCall("getNativeTopBarHeight", {});
}
/**
 * 关闭当前的H5页面
 * @callName backPage
 */
function backPage() {
    return proxyCall("backPage", {});
}
/**
 * 隐藏当前的H5客服页面
 * @callName hideCustomerView
 */
function hideCustomerView() {
    return proxyCall("hideCustomerView", {});
}
/**
 * 用于代理项目，保存图片到本地
 * @callName savePictureToLocal
 * @param params
 */
function savePictureToLocal(params) {
    return proxyCall("savePictureToLocal", params);
}
/**
 * 隐藏或者显示原生的底部tabbar
 * @callName toggleMainTabBar
 * @param params
 */
function toggleMainTabBar(params) {
    return proxyCall("toggleMainTabBar", params);
}
/**
 * 传递H5页面的高度给原生
 * @callName sendH5DocHeightToNative
 * @param params
 */
function sendH5DocHeightToNative(params) {
    return proxyCall("sendH5DocHeightToNative", params);
}
/**
 * 设置原生app的title
 * @callName sendH5DocHeightToNative
 * @param params
 */
function setNativeTitle(params) {
    return proxyCall("setNativeTitle", params);
}
/**
 * 打开游戏
 * @callName startGame
 * @param params
 */
function startGame(params) {
    return proxyCall("startGame", params);
}
// /**
//  * 获取app进入广场所需设置的赛事源
//  * @callName getMatchSourceOfInfoPortal
//  */
// function getMatchSourceOfInfoPortal() {
//   return proxyCall< string>("getMatchSourceOfInfoPortal", {});
// }
/**
 *
 * @param packageName 包名
 * @returns
 */
function openAndroidApp(params) {
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve) { return __awaiter(_this, void 0, void 0, function () {
                    var timer, visibilitychange;
                    return __generator(this, function (_a) {
                        timer = setTimeout(function () {
                            resolve(false);
                        }, 2200);
                        visibilitychange = function () {
                            var tag = document.hidden || document.webkitHidden;
                            tag && clearTimeout(timer);
                            resolve(true);
                        };
                        document.addEventListener("visibilitychange", visibilitychange, false);
                        document.addEventListener("webkitvisibilitychange", visibilitychange, false);
                        window.addEventListener("pagehide", function () {
                            clearTimeout(timer);
                            resolve(true);
                        }, false);
                        proxyCall("sendOpenAndroidApp", params);
                        return [2 /*return*/];
                    });
                }); })];
        });
    });
}
/**
 * 唤起原生App
 * @param {string} schema
 * @param {number} delay
 * @returns {Promise} true 唤起成功 | false 唤起失败
 */
function openApp(schema, delay) {
    if (delay === void 0) { delay = 2500; }
    return new Promise(function (resolve) {
        var a = document.createElement("a");
        a.setAttribute("href", schema);
        a.click();
        var timer = setTimeout(function () {
            resolve(false);
        }, delay);
        var visibilitychange = function () {
            var tag = document.hidden || document.webkitHidden;
            tag && clearTimeout(timer);
            resolve(true);
        };
        document.addEventListener("visibilitychange", visibilitychange, false);
        document.addEventListener("webkitvisibilitychange", visibilitychange, false);
        window.addEventListener("pagehide", function () {
            clearTimeout(timer);
            resolve(true);
        }, false);
    });
}
/**
 * 唤起app扫码功能，登录成功会触发onScanSuccess事件
 * @callName openAppScan
 */
function openAppScan() {
    return proxyCall("openAppScan", {});
}
function setAppCoinCode(params) {
    return proxyCall("setAppCoinCode", params);
}
/**
 * 获取主播代理开关状态
 */
function getAnchorProxyStatus() {
    return proxyCall("getAnchorProxyStatus", {});
}
export default __assign(__assign(__assign({ openApp: openApp }, dsbridge), event), { openAndroidApp: openAndroidApp,
    checkApp: checkApp,
    jumpToH5Page: jumpToH5Page,
    jumpToBrowserPage: jumpToBrowserPage,
    jumpToNativePage: jumpToNativePage,
    jumpToNativeLogin: jumpToNativeLogin,
    notify: notify,
    getCurrentTheme: getCurrentTheme,
    getCurrentLanguage: getCurrentLanguage,
    getCurrentCoinCode: getCurrentCoinCode,
    getCountry: getCountry,
    getLoginInfo: getLoginInfo,
    getAgentLoginInfo: getAgentLoginInfo,
    getNativeInfo: getNativeInfo,
    getNativeTopBarHeight: getNativeTopBarHeight,
    backPage: backPage,
    hideCustomerView: hideCustomerView,
    savePictureToLocal: savePictureToLocal,
    toggleMainTabBar: toggleMainTabBar,
    sendH5DocHeightToNative: sendH5DocHeightToNative,
    startGame: startGame,
    setNativeTitle: setNativeTitle,
    openAppScan: openAppScan,
    setAppCoinCode: setAppCoinCode,
    getAnchorProxyStatus: getAnchorProxyStatus,
    testNotExist: testNotExist });
